<header>
  <h1 mat-dialog-title><i *ngIf="data.titleIcon" class="{{ data.titleIcon }}"></i>{{ data.title }}</h1>
  <aside>
    <i class="material-icons notranslate" [matTooltip]="'Close'" (click)="dialogRef.close(false);" matTooltipShowDelay="500">close</i>
  </aside>
</header>
<div mat-dialog-content class="grid-2">
  <i *ngIf="data.messageIcon" class="{{ data.messageIcon }}"></i>
  <h2 *ngIf="data.message" [innerHTML]="data.message"></h2>
  <img *ngIf="data.image" class="hero-image" src="{{data.image}}" [matTooltip]="data.imageTitle" matTooltipShowDelay="500"> <!-- TODO: Make 'hero-image' class optional -->
</div>
<section *ngIf="!(data.hideCancelButton || data.hideConfirmButton)" mat-dialog-actions class="footer-btns">
  <button *ngIf="!data.hideCancelButton" mat-button (click)="onNoClick()"
          class="danger-btn-hover" theme-style="nav" appRipple>No</button>
  <button *ngIf="!data.hideConfirmButton" mat-button [mat-dialog-close]="data" theme-style="nav" appRipple>{{ data.confirmButtonText }}</button>
</section>
